import { AddIncidentReportFormModalContext } from '@/contexts'
import { useContext } from 'react'

export const useAddIncidentReportFormModalContext = () => {
  const context = useContext(AddIncidentReportFormModalContext)

  if (!context) throw new Error('useAddIncidentReportFormModalContext have to be wrapped by AddIncidentReportFormModalContextProvider')
  
  return context
}
